// removed by extract-text-webpack-plugin
module.exports = {"groupContainer":"_-src-components-AutocompleteList-components-AutocompleteItem-index---groupContainer---1oYss","loader":"_-src-components-AutocompleteList-components-AutocompleteItem-index---loader---E5cvh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AutocompleteList/components/AutocompleteItem/index.css
// module id = 809
// module chunks = 1